/** @jsx jsx */
import { jsx } from '@emotion/react';
import React from 'react';
import { useData } from '../Data';
import { LinkListSection, coursePicture } from '../UzlDesign';
import { useFile } from 'components/useFile';

export function TeachingTop() {
  const { semesters, lang, urls } = useData();
  const en = lang === 'en';
  // newest first; "Semesterunabhängig" (abc "zzzzz") belongs to the current ones
  const sorted = [...Object.values(semesters.courses)].sort((a: any, b: any) => b.abc.localeCompare(a.abc)) as any[];
  const dated = sorted.filter((s) => s.abc !== 'zzzzz');
  // the two newest regular semesters are current; a trimester (ST/WT) goes with its year
  const regular = dated.filter((s) => /^(wise|sose)-/.test(s.id));
  const cut = regular[1]?.abc ?? '';
  const current = [...sorted.filter((s) => s.abc === 'zzzzz'), ...dated.filter((s) => s.abc >= cut)];
  const past = dated.filter((s) => s.abc < cut);
  // a photo of one of the current courses next to the list
  const [latest] = useFile(regular[0] && `${urls.dataroot}static/${regular[0].file}`, (r) => r.json());
  const picture = (latest?.courses ?? []).map(coursePicture).find(Boolean);
  const item = (semester: any) => ({ label: semester.name, href: `#${semester.id}` });
  return (
    <div>
      <h1>{en ? 'Teaching' : 'Lehre'}</h1>
      <LinkListSection title={en ? 'Current semesters' : 'Aktuelle Semester'} image={picture}
        intro={<p>{en ? 'Lectures, seminars and lab courses of the Institute of Computer Engineering.'
                      : 'Vorlesungen, Seminare und Praktika des Instituts für Technische Informatik.'}</p>}
        items={current.map(item)} />
      {past.length > 0 && <LinkListSection title={en ? 'Past semesters' : 'Frühere Semester'}
        intro={<p>{en ? 'What the institute taught in earlier semesters, from Moodle and the old website.'
                      : 'Was das Institut in früheren Semestern gelehrt hat, aus Moodle und der alten Webseite.'}</p>}
        items={past.map(item)} />}
    </div>
  );
}
